<template>
  <CRow>
    <CCol col="12" xl="12" v-if="form">
      <!-- <transition name="slide"> -->
      <CCard style="float:left;">
        <CCardHeader>
          Order Details
        </CCardHeader>
        <CCardBody v-if="form">
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>

          <!-- Customer Information -->
          <div style="width:100%;" class="float-left">
            <h4 style="width:100%;float:left;text-align:center;"><b>Status:</b> {{form.status.replace("_", " ")}}</h4>
            <CCol sm="12" class="float-left mb-3">
              <label><b>Order #:</b> {{form.order_id}}</label>
            </CCol>
            <CCol sm="12" class="float-left mb-3">
              <label><b>PO Number:</b> {{form.po_number}}</label>
            </CCol>
            <!-- <CCol sm="12" class="float-left">
              <CInput
                label="Paramount Order Number"
                placeholder="Enter paramount order number"
                v-model="form.paramount_order_number"
              />
            </CCol>
            <CCol sm="12" class="float-left">
              <CInput
                label="Log Number"
                placeholder="Enter log number"
                v-model="form.log_number"
              />
            </CCol> -->
            <!-- <CCol sm="12" class="float-left">
              <CInput
                label="Customer Number"
                placeholder="Enter customer number"
                v-model="form.customer_number"
              />
            </CCol> -->
            <!-- <CCol col="12" class="float-left mb-3">
              <label><b>Log Number:</b> {{form.log_number}}</label>
            </CCol> -->
            <CCol col="12" class="float-left mb-3">
              <label><b>Customer Name:</b> {{form.customer_info.customer_name}}</label>
            </CCol>
            <CCol col="12" class="float-left mb-3">
              <label><b>Customer Number:</b> {{form.customer_info.customer_number}}</label>
            </CCol>
            <!-- <CCol sm="12" class="float-left">
              <CInput
                label="Ship To Number"
                placeholder="Enter ship to number"
                v-model="form.ship_to"
              />
            </CCol> -->
            <CCol col="12" class="float-left mb-3">
              <label><b>Sold To:</b></label>
              <ul>
                <li>{{form.customer_info.customer_name}}</li>
                <li>{{form.customer_info.address_1}}</li>
                <li>{{form.customer_info.city}}, {{form.ship_to_info.state}}, {{form.ship_to_info.zip_code}}</li>
              </ul>
            </CCol>
            <CCol col="12" class="float-left mb-3">
              <label><b>Ship To:</b></label>
              <ul>
                <li>{{form.ship_to_info.ship_name}}</li>
                <li>{{form.ship_to_info.address_1}}</li>
                <li>{{form.ship_to_info.city}}, {{form.ship_to_info.state}}, {{form.ship_to_info.zip_code}}</li>
              </ul>
            </CCol>

            <CCol sm="12" class="float-left">
              <label style="width:100%;float:left;cursor:pointer;" @click="pricingCollapsed = !pricingCollapsed">
                <b style="float:left;">Pricing (click to expand)</b>
                <b style="float:right;"><CIcon :name="`cil-chevron-${pricingCollapsed ? 'bottom' : 'top'}`"/></b>
              </label>
              <CCollapse :show="pricingCollapsed" :duration="400">
                <div style="width:100%;float:left;cursor:pointer;" @click="pricingCollapsed = !pricingCollapsed" v-if="form.customer_info">
                  <table class="table pricingTable" v-if="form.order_groups.length" v-for="v in form.order_groups">
                    <tbody style="width:100% !important;" v-for="(val, index) in v.order_items">
                      <tr>
                        <td colspan="4" style="text-align:center;"><b>{{val.style_name}} - {{val.style_description}}</b></td>
                      </tr>
                      <tr class="priceRow">
                        <td></td>
                        <td>Price</td>
                        <td>Pcs</td>
                        <td style="width:100px;">Total</td>
                      </tr>
                      <tr class="priceRow">
                        <td>Style Cost:</td>
                        <td>${{parseFloat(configureStyleCost(val)).toFixed(2)}}</td>
                        <td>{{configurePieces(val)}}</td>
                        <td>${{parseFloat(calculateCost(configureStyleCost(val), val)).toFixed(2)}}</td>
                      </tr>
                      <tr class="priceRow" v-for="(v, i) in val.order_item_locations">
                        <td>Technique Cost {{i+1}}</td>
                        <td>
                          ${{parseFloat(v.technique.cost).toFixed(2)}}
                        </td>
                        <td>{{configurePieces(val)}}</td>
                        <td>${{parseFloat(v.technique_cost).toFixed(2)}}</td>
                      </tr>
                      <!-- <tr class="priceRow">
                        <td>Decoration Price</td>
                        <td>
                          ${{parseFloat(configureDecorationPrice(val)).toFixed(2)}}
                        </td>
                        <td>{{configurePieces(val)}}</td>
                        <td>${{parseFloat(calculateCost(configureDecorationPrice(val), val)).toFixed(2)}}</td>
                      </tr> -->
                      <tr class="priceRow">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>${{parseFloat(configureItemPrice(val)).toFixed(2)}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table">
                    <tbody>
                      <tr class="priceRow">
                        <td>Total Price: </td>
                        <td></td>
                        <td></td>
                        <td style="width:100px;">${{total_price}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CCollapse>
            </CCol>

          </div>
        </CCardBody>
      </CCard>

          <!-- <hr style="width:100%;float:left;height:2px;background-color:#e0e0e0;margin-top:15px;margin-bottom:15px;" /> -->

      <div style="width:100%;float:left;" v-if="form.order_items.length">
        <transition name="fade">
          <CCard>
            <CCardHeader @click="orderItemsCollapsed = !orderItemsCollapsed">
              Order Items
              <div class="card-header-actions">
                <CLink class="card-header-action btn-minimize">
                  <CIcon :name="`cil-chevron-${orderItemsCollapsed ? 'bottom' : 'top'}`"/>
                </CLink>
              </div>
            </CCardHeader>
            <CCollapse :show="orderItemsCollapsed" :duration="400">
              <CTabs>
                <CTab v-for="(val, i) in form.order_groups" :title="'Group - ' + (i + 1)" :active="i === 0 ? true : false">
                  <CCardBody>
                    <div class="col-12 float-left mb-3" v-if="$store.state.user.user_type !== 'rep'">
                      <order-cc :group="val"></order-cc>
                    </div>
                    <!-- <div style="width:100%;float:left;margin-bottom:15px;"> -->
                      <div class="col-sm-12 text-center float-left" v-if="configureButtons(val) && $store.state.user.user_type !== 'rep'">
                        <CButton size="sm" class="m-1 float-left" color="success" @click="generate('artpacks', val)" v-if="configureButtonType(val, 'artpacks')">Generate Artpack(s)</CButton>
                        <CButton size="sm" class="m-1 float-left" color="success" @click="generate('escapes', val)">Generate Escape</CButton>
                        <CButton size="sm" class="m-1 float-left" color="info" @click="generate('components', val)" v-if="configureButtonType(val, 'components')">Generate Component(s)</CButton>
                        <CButton size="sm" class="m-1 float-left" color="danger" @click="generate('embroideries', val)" v-if="configureButtonType(val, 'embroideries')">Generate Embroidery</CButton>
                        <CButton size="sm" class="m-1 float-left" color="warning" @click="generate('heat_seals', val)" v-if="configureButtonType(val, 'heat_seals')">Generate Heat Seal(s)</CButton>
                      </div>
                    <!-- </div> -->
                    <spacer />
                    <CCol col="12" class="float-left mb-3">
                      <label><b>Log #:</b> {{val.log_number}}</label>
                    </CCol>
                    <CCol col="12" class="float-left mb-3">
                      <label><b>CC #:</b> {{val.cc_number || "CC number will appear when created."}}</label>
                    </CCol>
                    <CCol col="12" class="float-left mb-3">
                      <label><b>Prebook:</b> {{val.prebook}}</label>
                    </CCol>
                    <CCol col="12" class="float-left mb-3">
                      <label><b>Ship Via:</b> {{val.ship_via_code}} - {{val.ship_via_text}}</label>
                    </CCol>
                    <CCol col="12" class="float-left mb-3">
                      <label><b>Tracking #: </b> {{val.tracking_number || 'Tracking number will appear when shipped.' }}</label>
                    </CCol>
                    <CCol col="12" class="float-left p-0">
                      <CTabs>
                        <CTab v-for="(order, index) in val.order_items" :title="order.style_info.style_name" :active="index === 0 ? true : false">
                          <CCardBody>
                            <CCol col="12" class="float-left mb-3">
                              <label><b>Program:</b> {{order.program_info.program_name}}</label>
                              <!-- <div class="orderItemValue">{{order.program_name}}</div> -->
                            </CCol>

                            <CCol col="12" class="float-left mb-3">
                              <label><b>Style:</b> {{order.style_info.style_name}}</label>
                            </CCol>

                            <!-- <CCol col="12" class="float-left mb-3">
                              <label>Technique: {{order.technique_info.technique_name}}</label>
                            </CCol> -->

                            <CCol sm="12" class="float-left">
                              <label><b>Ship Date:</b></label>
                              <CInput
                                type="date"
                                v-model="order.ship_date"
                                disabled
                                horizontal
                              />
                            </CCol>
                            <CCol sm="12" class="float-left">
                              <label><b>Event Date:</b></label>
                              <CInput
                                type="date"
                                v-model="order.event_date"
                                disabled
                                horizontal
                              />
                            </CCol>

                            <CCol sm="12" class="float-left">
                              <label><b>Blank Order:</b> {{order.blank_order ? 'Yes' : 'No'}}</label>
                            </CCol>

                            <spacer />

                            <div class="float-left" style="width:100%;" v-if="!order.blank_order">
                              <!-- <hr style="width:100%;float:left;height:2px;background-color:#e0e0e0;margin-top:15px;margin-bottom:15px;" /> -->
                              <label style="width:100%;float:left;text-align:center;">Location Options</label>
                              <div v-for="(val, i) in order.order_item_locations" style="width:100%;float:left;">
                                <CCard color="gradient-secondary">
                                  <CCardHeader>
                                    Location #{{i + 1}}
                                  </CCardHeader>
                                  <CCardBody>
                                    <!-- <CCol col="12" class="float-left text-center" style="text-transform: capitalize;">
                                      Location: {{val.location_name}}
                                    </CCol>
                                    <CCol col="12" class="float-left text-center mt-2">
                                      Color Type: {{val.color_type}}
                                    </CCol> -->
                                    <table style="width:100%;">
                                      <thead>
                                        <tr>
                                          <th style="text-align:center;">Technique</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td style="text-align:center;">{{val.technique.technique_name}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table style="width:100%;">
                                      <thead>
                                        <tr>
                                          <th style="width:50%;text-align:center;">Location</th>
                                          <th style="width:50%;text-align:center;">Color Type</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td style="text-align:center;text-transform: capitalize;">{{val.location_name}}</td>
                                          <td style="text-align:center;">{{val.color_type}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <div style="width:100%;float:left; text-align:center;margin-top:15px;" v-if="val.decoration">
                                      <span v-if="val.decoration.file_url" style="width:100%;float:left;text-align:center;">
                                        <h5 style="font-size:11px;">{{val.decoration.name}}</h5>
                                        <!-- <img rel="preload" @click="viewImage(val.decoration)" :src="val.decoration.file_url" style="width:200px;cursor:pointer;" /><br /> -->
                                        <image-wrapper @img-clicked="viewImage(val.decoration)" imgStyle="width:200px;cursor:pointer;" :src="val.decoration.file_url" />
                                        <CButton size="sm" color="info" class="mt-2" @click="downloadFile(val)">
                                          Download File <CIcon name="cil-cloud-download" />
                                        </CButton>
                                      </span>
                                    </div>
                                    <!-- <div style="width:100%;float:left; text-align:center;margin-top:15px;" v-if="val.new_decoration">
                                        <h5 style="font-size:13px;color:green;">New Decoration!</h5>
                                        <img rel="preload" :src="val.file_url" style="width:200px;" />
                                    </div> -->
                                    <CCol col="12" class="float-left p-2">
                                      <textarea style="width:100%;" disabled v-model="val.decoration_instructions" placeholder="Decoration Instructions..." row="4"></textarea>
                                    </CCol>
                                  </CCardBody>
                                </CCard>
                              </div>
                            </div>
                            <div style="width:100%;float:left;" v-if="order.order_item_colors">
                              <CCard color="gradient-secondary">
                                <CCardHeader>
                                  Colors
                                </CCardHeader>
                                <CCardBody>
                                  <div style="width:100%;float:left;">
                                    <h5 style="width:100%;float:left;text-align:center;padding:15px;font-size:12px;">Min Quantity: {{order.style_info.min_quantity}}</h5>
                                    <table class="table">
                                      <thead>
                                        <tr>
                                          <th style="">Color</th>
                                          <th style="text-align:center;width:100px;text-align:center;" v-for="(val, index) in configureSizes(order.order_item_colors)">{{val.size_name}}</th>
                                          <th>Dec Instructions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="color in order.order_item_colors">
                                          <td style="padding:0px;padding-top:7px;vertical-align: center;">{{color.color_name}} ({{color.color_code}})</td>
                                          <td style="padding:0px;text-align:center;" v-for="(size, index) in color.sizes">
                                            <!-- <CInput
                                              type="number"
                                              style="margin-bottom:0px !important;text-align:center !important;"
                                              v-model="size.quantity"
                                              @change="checkQuantity(size)"
                                              :placeholder="size.size_name"
                                              :min="order.style_info.min_quantity"
                                              inheritAttrs="true"
                                            /> -->
                                            {{size.quantity}}
                                            <!-- <label class="availableQuantity">{{size.available_quantity}}</label> -->
                                          </td>
                                          <td style="padding:0px;text-align:center;">
                                            {{color.instructions ? color.instructions : ''}}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="padding:0px;padding-top:7px;vertical-align: center;font-weight:900;">
                                            Total
                                          </td>
                                          <td style="text-align:center;">
                                            <b>{{configureTotalSizes(order.order_item_colors)}}</b>
                                          </td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </CCardBody>
                              </CCard>
                            </div>

                              <div style="width:100%;float:left;">
                                <label>Special Instructions</label>
                                <textarea style="width:100%;" disabled v-model="order.special_instructions" placeholder="Special Instructions..." row="5"></textarea>
                              </div>
                          </CCardBody>
                        </CTab>
                      </CTabs>
                    </CCol>
                  </CCardBody>
                </CTab>
              </CTabs>
            </CCollapse>
          </CCard>
        </transition>
      </div>

      <!-- <div style="width:100%;float:left;" v-if="form">
        testing
        <pdf-order :form="form"></pdf-order>
      </div> -->
      <!-- </transition> -->
    </CCol>

    <CModal
      title="Generate Request"
      :show.sync="generateModal"
      size="lg">
      <div style="width:100%;float:left;" v-if="generateGroup">
        <component-request v-if="generateType === 'components'" @submitted="submitChange" :group="generateGroup" :newData="form"></component-request>
        <escape-request v-if="generateType === 'escapes'" :group="generateGroup" :newData="form"></escape-request>
        <artpack-request v-if="generateType === 'artpacks'" :group="generateGroup" :newData="form"></artpack-request>
        <embroidery-request v-if="generateType === 'embroideries'" :group="generateGroup" :newData="form"></embroidery-request>
        <heat-seal-request v-if="generateType === 'heat_seals'" :group="generateGroup" :newData="form"></heat-seal-request>
      </div>
    </CModal>
  </CRow>
</template>

<script>
import { validationMixin } from "vuelidate"
import PdfOrder from './../components/pdf_order'
// import OrderCc from './order_cc'
const OrderCc = () => import('./order_cc.vue')
import EscapeRequest from './../flow/escape_request'
import ArtpackRequest from './../flow/artpack_request'
import EmbroideryRequest from './../flow/embroidery_request'
import ComponentRequest from './../flow/component_request'
import HeatSealRequest from './../flow/heat_seal_request'
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"
import Swal from 'sweetalert2'
var methods = {}

methods.submitChange = function () {
  this.generateModal = false
  this.generateGroup = null
  this.generateType = ''
}

methods.generate = function (type, val) {
  this.generateType = type
  this.generateGroup = val
  this.generateModal = true
}

methods.getOrder = function () {
  const postData = {
    order_id: this.order_id
  }
  axios.post(this.$apiAdress + '/api/orders/getOrderDisplay?token='+localStorage.getItem('api_token'), postData)
  .then(response => {
    var arr = []
    response.data.order_items.forEach(function (val) {
      arr.push(false)
    })
    this.collapsed = arr
    this.form = response.data
    this.$emit('got-order', response.data)
  }).catch(e => {
    console.log(e)
    if (e.response.status === 422) {
      this.$router.push('/login')
    }
  })
}

methods.configureButtons = function (value) {
  console.log('configure buttons')
  console.log(value)
  var t = false
  if (value.cc_number) {
    t = true
    // value.order_items.forEach(function (item) {
    //   console.log(item)
    //   item.order_item_locations.forEach(function (location) {
    //     if (location.decoration.req_type === 'artpacks' || location.new_decoration) {
    //       t = true
    //     }
    //   })
    // })
  }
  return t
}

methods.configureButtonType = function (value, type) {
  var t = false
  value.order_items.forEach(function (item) {
    console.log(item)
    item.order_item_locations.forEach(function (location) {
      if (location.decoration.req_type === 'artpacks' || location.new_decoration) {
        if (type !== 'artpacks') {
          if (location.technique.type === type) {
            t = true
          }
        } else {
          if (location.new_decoration) {
            t = true
          }
        }
      }
    })
  })
  return t
}

methods.modalClose = function () {
  this.currentViewImage = []
  this.galleryIndex = null
}

methods.viewImage = function (image) {
  this.currentViewImage = [image.file_url]
  this.galleryIndex = 0
}

methods.downloadFile = function (val) {
  let self = this
  this.downloadFileName = name
  axios({
      method: 'get',
      url:  this.$apiAdress + '/api/media/file/download?thisFolder=' + val.decoration.model_id + '&id=' + val.decoration.id + '&token=' + localStorage.getItem("api_token"),
      responseType: 'arraybuffer'
  })
  .then(function(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', val.decoration.name)
      document.body.appendChild(link)
      link.click()
  })
  .catch(function(error){
      console.log(error)
      // self.$router.push({ path: '/login' })
  });

}

methods.configureSizes = function (colors) {
  var obj = {}
  if (colors) {
    colors.forEach(function (color) {
      color.sizes.forEach(function (size) {
        if (!obj[size.size_id]) {
          obj[size.size_id] = size
        }
      })
    })
  }
  return obj
}

methods.calculateTechCost = function (cost, order, index) {
  var i = 0
  var z = 0
  var total = 1
  var total2 = 0
  var b = 1
  order.order_item_locations.forEach(function (val) {
    if (index + 1 > order.program_info.free_decorations) {
      if (order.order_item_locations[z].technique.technique_name === 'Flat Embroidery') {
        if (i === 0 && index === z) {
          total = 0
        } else {
          i = 1
        }
        // else {
        //   return parseFloat(cost * this.configurePieces(order))
        // }
      }
      total2 = 1
    }
    // else {
    //   return parseFloat(cost * this.configurePieces(order))
    // }
    z++
    // i++
  })
  if (total && total2) {
    return parseFloat(cost * this.configurePieces(order))
  } else {
    return 0
  }
}

methods.configureStyleCost = function (val) {
  if (val.program_info.program_name === 'Domestic') {
    var cost = val.style_info['price_' + this.form.customer_info.pricing_level_code]
    if (val.blank_order) {
      cost = parseFloat(cost) - 1.75
    }
    return cost
  } else {
    var pieces = this.configurePieces(val)
    var cost = ''
    if (pieces < 24) {
      cost = val.style_info['price_min_12']
    } else if (pieces < 36) {
      cost = val.style_info['price_min_24']
    } else if (pieces < 72) {
      cost = val.style_info['price_min_36']
    } else if (pieces >= 72) {
      cost = val.style_info['price_min_72']
    }
    if (val.blank_order) {
      cost = parseFloat(cost) - 1.75
    }
    return cost
  }
}

methods.configurePieces = function (order) {
  var sizes = 0
  if (order.order_item_colors.length) {
    order.order_item_colors.forEach(function (val) {
      if (val.sizes.length) {
        val.sizes.forEach(function (size) {
          if (size.quantity) {
            sizes += parseInt(size.quantity)
          }
        })
      }
    })
  }
  return sizes
}

methods.calculateCost = function (cost, order) {
  cost = parseFloat(cost)
  return parseFloat(cost * this.configurePieces(order))
}

methods.configureDecorationPrice = function (order) {
  var decorationCost = 0
  // if (order.technique_info) {
    if (order.order_item_locations.length > 1) {
      var i = 0
      var locations = 0
      order.order_item_locations.forEach(function (location) {
        if (i > 0) {
          locations++
        }
        i++
      })
      decorationCost = parseFloat(parseFloat(order.program_info.cost) * locations)
    }
  // }
  return decorationCost
}

methods.configureTechniqueCost = function (order) {
  // var techCost = 0
  // var that = this
  // order.order_item_locations.forEach(function (val) {
  //   if (val.technique) {
  //     techCost += parseFloat(parseFloat(val.technique.cost) * that.configurePieces(order))
  //   }
  // })
  // return techCost
  var techCost = 0
  var that = this
  var z = 0
  order.order_item_locations.forEach(function (val) {
    console.log(val)
    // if (val.technique) {
      // if (val.technique.technique_name === 'Flat Embroidery' && z !== 0) {
        techCost += parseFloat(parseFloat(val.technique_cost))
      // } else if (val.technique.technique_name === 'Flat Embroidery') {
      //   z = 1
      // } else {
      //   techCost += parseFloat(parseFloat(val.technique.cost) * that.configurePieces(order))
      // }
    // }
  })
  return techCost
}

methods.configureItemPrice = function (order) {
  var total = 0
  var that = this
  // if (order.technique_info) {

    var styleCost = parseFloat(this.configureStyleCost(order))
    // var techCost = parseFloat(order.technique_info.cost)
    var techCost = parseFloat(this.configureTechniqueCost(order))
    // var decorationCost = this.configureDecorationPrice(order)
    
    var sizes = this.configurePieces(order)
    total += parseFloat((parseFloat(styleCost)) * parseInt(sizes)) + parseFloat(techCost)
  // }
  return total
}

methods.configureTotalSizes = function (colors) {
  var total = 0
  colors.forEach(function (color) {
    color.sizes.forEach(function (size) {
      total += parseInt(size.quantity)
    })
  })
  return total
}

methods.collapseClicked = function (index) {
  console.log(index)
  this.collapsed[index] = !this.collapsed[index]
  this.$forceUpdate()
}

methods.addToOrder = function () {
  this.form.order_info.push(this.order_details)
  this.order_details = this.getOrderDetails()
}

methods.getOrderDetails = function () {
  return {
    program_selected: '',
    technique_selected: '',
    style_selected: '',
    decoration_selected: '',
    colors_selected: [
      {color: '', size: '', quantity: '', sizes: []}
    ],
    locations_selected: [
      {location: '', decoration: '', decoration_instructions: ''}
    ],
    special_instructions: '',
    collapsed: false
  }
}

methods.sizeValChanged = function (val) {

}

methods.getData = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.programOptions = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.getCustomers = function () {
  let self = this
  const postData = {
    rep_number: this.$store.state.user.rep_number
  }
  axios.post( this.$apiAdress + '/api/getRepCustomers?token=' + localStorage.getItem("api_token"), postData)
  .then(function (response) {
    console.log(response)
    self.customerOptions = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.programClicked = function (val, selected, id, filler, innertable, table, table_id) {
  this.form[selected] = val
  this.getNewInfo(val, id, filler, innertable, table, table_id)
}

methods.styleClicked = function (val) {
  let self = this
  this.order_details.style_selected = val
  const postData = {
    style_id: val.style_id,
    technique_id: this.order_details.technique_selected.technique_id
  }
  axios.post( this.$apiAdress + '/api/orders/getDecorations?token=' + localStorage.getItem("api_token"), postData)
  .then(function (response) {
    console.log(response)
    // self[filler] = response.data
    self.decorationOptions = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.getNewInfo = function (val, id, filler, innertable, table, table_id) {
  let self = this
  const postData = {
    table: table,
    where: id,
    id: val[id],
    innertable: innertable,
    table_id: table_id
  }
  axios.post( this.$apiAdress + '/api/orders/getOptions?token=' + localStorage.getItem("api_token"), postData)
  .then(function (response) {
    console.log(response)
    if (filler !== 'sizeOptions') {
      self[filler] = response.data
    } else {
      self.sizeOptions = []
      console.log(self.order_details)
      response.data.forEach(function (size) {
        var obj = {
          size_id: size.size_id,
          size_name: size.size_name,
          cost: size.cost,
          quantity: ''
        }
        self.sizeOptions.push(obj)
        self.order_details.colors_selected[0].sizes.push(obj)
      })
    }
  }).catch(function (error) {
    console.log(error)
  });
}

methods.selectedImage = function () {
  this.order_details.locations_selected[this.imageIndex].decoration = this.imageSelected
  this.imageIndex = ''
  this.imageSelected = ''
  this.fileModal = false
}

methods.loadDecorations = function (index) {
  let self = this
  this.imageIndex = index
  const postData = {
    customer_number: this.form.customer_selected.customer_number,
    technique_type: this.form.technique_selected.technique_type
  }
  axios.post(this.$apiAdress + '/api/orders/getFlowDecorations?token=' + localStorage.getItem('api_token'), postData)
  .then(function (response) {
    console.log(response)
    self.fileModal = true
    // self.images = response.data.files
    self.images = []
    response.data.files.forEach(function (file) {
      if (file.extension === 'jpg') {
        self.images.push(file)
      }
    })
  }).catch(function (error) {
    console.log(error)
  })
}

methods.reset = function () {
  this.form = {name: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.edit = function (val) {
  // this.$router.push({ path: '/styles/' + val + '/edit' })
  this.editForm = val
  this.editModal = true
}

methods.getForm = function () {
  return {
    order_info: [],
    colors_selected: [
      {color: '', size: '', quantity: '', sizes: this.sizeOptions}
    ],
    locations_selected: [
      {location: '', decoration: '', decoration_instructions: ''}
    ],
    ship_to: '',
    po_number: '',
    paramount_order_number: '',
    log_number: '',
    ship_date: '',
    event_date: '',
    customer_selected: ''
  }
}

methods.removeColor = function (val, index) {
  if (this.order_details.colors_selected.length > 1) {
    this.order_details.colors_selected.splice(index, 1)
  } else {
    this.order_details.colors_selected = [{color: '', size: '', quantity: '', sizes: this.sizeOptions}]
  }
}

methods.removeLocation = function (val, index) {
  if (this.order_details.locations_selected.length > 1) {
    this.order_details.locations_selected.splice(index, 1)
  } else {
    this.order_details.locations_selected = [{location: '', decoration: '', decoration_instructions: ''}]
  }
}

methods.addColor = function () {
  var sizes = []
  this.sizeOptions.forEach(function (size) {
    var obj = {
      size_id: size.size_id,
      size_name: size.size_name,
      cost: size.cost,
      quantity: ''
    }
    sizes.push(obj)
  })
  this.order_details.colors_selected.push({color: '', size: '', quantity: '', sizes: sizes})
}

// Getting Ship tos based on the customer that was selected
methods.getShipTos = function () {
  axios.post(this.$apiAdress + '/api/getShipToByCustomer?token=' + localStorage.getItem("api_token"), this.form.customer_selected)
  .then(res => {
    console.log(res)
    this.shipToOptions = res.data
  }).catch(error => {
    this.$store.commit('axios_error', error)
  })
}

export default {
  name: 'OrderDisplay',
  props: ['order_id'],
  data() {
    return {
      items: [],
      collapsed: [],
      orderItemsCollapsed: true,
      fields: ['color_id', 'color_name', 'color_code', 'edit'],
      currentPage: 1,
      fileModal: false,
      pricingCollapsed: false,
      perPage: 5,
      totalRows: 0,
      order_details: {
        program_selected: '',
        technique_selected: '',
        style_selected: '',
        decoration_selected: '',
        colors_selected: [
          {color: '', size: '', quantity: '', sizes: []}
        ],
        locations_selected: [
          {location: '', decoration: '', decoration_instructions: ''}
        ],
        special_instructions: '',
        collapsed: false
      },
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: null,
      editForm: null,
      editModal: false,
      programOptions: null,
      techniqueOptions: null,
      styleOptions: null,
      decorationOptions: null,
      colorOptions: null,
      sizeOptions: null,
      locationOptions: null,
      images: null,
      imageIndex: '',
      imageSelected: '',
      customerOptions: null,
      shipToOptions: [],
      currentViewImage: [],
      galleryIndex: null,
      generateType: '',
      generateGroup: '',
      generateModal: false,
    }
  },
  // mixins: [validationMixin],
  // validations: {
  //   color_name: '',
  //   color_code: '',
  //   program_selected: '',
  //   technique_selected: '',
  //   style_selected: '',
  //   decoration_selected: '',
  //   colors_selected: [
  //     {color: '', size: '', quantity: ''}
  //   ],
  //   locations_selected: [
  //     {location: '', decoration: ''}
  //   ],
  //   customer_number: {
  //     required
  //   },
  //   ship_to: {
  //     required
  //   },
  //   po_number: {
  //     required
  //   },
  //   log_number: {
  //     required
  //   },
  //   ship_date: {
  //     required
  //   },
  //   customer_selected: {
  //     required,
  //   }
  // },
  components: {
    PdfOrder,
    EscapeRequest,
    ArtpackRequest,
    EmbroideryRequest,
    ComponentRequest,
    HeatSealRequest,
    OrderCc,
  },
  computed: {
    total_price() {
      var total = 0
      var styleCost = ''
      var techCost = ''
      
      var that = this
      if (this.form) {
        if (this.form.order_groups.length) {
          console.log(total)
          this.form.order_groups.forEach(function (group) {
            group.order_items.forEach(function (order) {
              // var styleCost = parseFloat(order.style_info['price_' + that.form.customer_info.pricing_level_code])
              // var techCost = parseFloat(order.technique_info.cost)
              // var sizes = 0
              // order.order_item_colors.forEach(function (val) {
              //   val.sizes.forEach(function (size) {
              //     sizes += parseInt(size.quantity)
              //   })
              // })
              // total += parseFloat((parseFloat(styleCost) + parseFloat(techCost)) * parseInt(sizes))
              total += that.configureItemPrice(order)
            })
          })
        }
      }
      return parseFloat(total).toFixed(2)
    }
  },
  watch: {
    'order_details.technique_selected': function (newVal, oldVal) {
      this.order_details.style_selected = ''
      this.styleOptions = null
      this.decorationOptions = null
    },
    'order_details.program_selected': function (newVal, oldVal) {
      this.order_details.technique_selected = ''
      if (newVal) {
        this.programClicked(newVal, 'program_selected', 'program_id', 'techniqueOptions', 'program_techniques', 'techniques', 'technique_id')
      }
    },
    'order_details.technique_selected': function (newVal, oldVal) {
      this.order_details.style_selected = ''
      if (newVal) {
        this.programClicked(newVal, 'technique_selected', 'technique_id', 'styleOptions', 'technique_styles', 'styles', 'style_id')
      }
    },
    'order_details.style_selected': function (newVal, oldVal) {
      this.order_details.decoration_selected = ''
      console.log(newVal)
      if (newVal) {
        this.programClicked(newVal, 'style_selected', 'style_id', 'colorOptions', 'style_colors', 'colors', 'color_id')
        this.programClicked(newVal, 'style_selected', 'style_id', 'sizeOptions', 'style_sizes', 'sizes', 'size_id')
        this.programClicked(newVal, 'style_selected', 'style_id', 'locationOptions', 'style_locations', 'locations', 'location_id')
        // this.styleClicked(newVal, 'technique_selected', 'technique_id', 'colorOptions', 'technique_styles', 'styles', 'style_id')
      }
    },
    'form.customer_selected': function (newVal, oldVal) {
      if (newVal) {
        this.getShipTos()
      }
    },
    order_id(newVal) {
      if (newVal) this.getOrder();
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getOrder()
    if (this.order_id) this.getOrder()
  }
}
</script>
<style lang="scss" scoped>
.selected {
  background-color: green;
}
</style>